import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";

/*
 * For certain views, such as those that depend on "ephemeral" UI state,
 * we don't worry about synchronizing ui state with updates. For example,
 * if you are editing a device model in ui state, and you save. Then you
 * will need to refresh your view to cause the component to fetch
 * the up-to-date device from the API. This is because we don't want to
 * synchronize changes to page/ui state by wiring up redux actions.
 *
 * The idea here is 1) avoid bugs by missing certain actions. And 2)
 * use ui state as a way to enable "undo" like functionality between
 * a ui state device and the device in the device store.
 */
function RefreshView({ history, location }) {
  const link = history.createHref(location);

  const to = {
    pathname: "/redirect",
    search: `to=${link}`,
  };

  return <Redirect to={to} />;
}

RefreshView.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export { RefreshView };
